import Controller, { OnMount } from '@philips-internal/oswald-ui-core/lib/client';
import { HttpService } from '@philips-internal/oswald-ui-core/lib/services';
import { HttpResponse } from '@philips-internal/oswald-ui-core/lib/services/http-service';
import { Inject } from '@odinjs/odin';
import { APPLICATION_ENDPOINTS } from '../../constants/application-endpoints';
import BaseController from '../BaseController';
import AccountCreationBlackboard from './account-creation-blackboard';
import { APPLICATION_ROUTES } from '../../constants/application-routes';

interface AccountCreationResult {
  success: boolean;
  messagekey: string;
  params?: string[];
}

@Controller({ fragment: 'account-creation-processing', component: 'layout-account-creation-processing' })
export default class AccountCreationProcessingController extends BaseController {

  @Inject('AccountCreationBlackboard')
    accountCreationBlackboard: AccountCreationBlackboard;

  created = 201;

  @OnMount({ target: 'layout-account-creation-processing' })
  onMountLayoutAccountCreationCompleted(): void {
    const body = this.accountCreationBlackboard.accountData;

    HttpService.post(APPLICATION_ENDPOINTS.CREATE_NEW_ACCOUNT, {}, { body })
      .then(r => this.handleCreationSuccess(r))
      .catch(e => this.handleCreationError(e))
      .finally(() => this.historyService.push(APPLICATION_ROUTES.ACCOUNT_CREATION_COMPLETED));
  }

  private async handleCreationSuccess(response: HttpResponse<unknown>): Promise<HttpResponse<unknown>> {
    const { status } = response;

    if (status !== this.created) {
      throw 'Internal Server Error';
    }

    return response;
  }

  private handleCreationError({ body }: { body: AccountCreationResult }): void {
    let errorMessage = 'newaccount.error.internal.server.error';

    if (body) {
      const result = body as unknown as AccountCreationResult;
      errorMessage = result.messagekey;
    }

    this.accountCreationBlackboard.accountData = { errorMessage };
  }
}